export default __webpack_public_path__ + "static/media/carousel-pic-four.eea8d043.png";